<template>
	<div>
		<div class="response-types">
			<div
				class="response-type shadow-sm"
				:class="{'response-type--selected': selectedResponse === 'text'}"
				@click="setCommandResponseType('text') "
			>
				<h4>Static Text</h4>
				<button class="btn btn-block my-2 btn-primary" @click="setCommandResponseType('text') ">Choose</button>
			</div>

			<!-- <div
				class="response-type shadow-sm"
				:class="{'response-type--selected': selectedResponse === 'static_cards'}"
				@click="setCommandResponseType('static_cards')"
			>
				<h4>Static Cards</h4>
				<button
					class="btn btn-block my-2 btn-primary"
					@click="setCommandResponseType('static_cards')"
				>Choose</button>
			</div> -->

			<div
				class="response-type shadow-sm"
				:class="{'response-type--selected': selectedResponse === 'api'}"
				@click="setCommandResponseType('api')"
			>
				<h4>API</h4>
				<button class="btn btn-block my-2 btn-primary" @click="setCommandResponseType('api')">Choose</button>
			</div>

			<div
				class="response-type shadow-sm"
				:class="{'response-type--selected': selectedResponse === 'dataset'}"
				@click="setCommandResponseType('dataset')"
			>
				<h4>Data Set</h4>

				<select name="dataSource" v-model="commandResponse.resp_dataset_id" class="form-control">
					<option
						v-for="dataSet in dataSets"
						:value="dataSet.ds_id"
						:key="`dataSet-${dataSet.ds_id}`"
						:selected="commandResponse.resp_dataset_id === dataSet.ds_id"
					>{{ dataSet.ds_name }}</option>
				</select>

				<button class="btn btn-block my-2 btn-primary" @click="setCommandResponseType('dataset')">Choose</button>
			</div>

			<div
				class="response-type shadow-sm"
				:class="{'response-type--selected': selectedResponse === 'datasource'}"
				@click="setCommandResponseType('datasource')"
			>
				<h4>Data Source</h4>
				<select name="dataSource" v-model="commandResponse.resp_data_source_id" class="form-control">
					<option
						v-for="dataSource in dataSources"
						:value="dataSource.data_source_id"
						:key="`dataSource-${dataSource.data_source_id}`"
						:selected="commandResponse.resp_data_source_id === dataSource.data_source_id"
					>{{ dataSource.entity.dbname }}</option>
				</select>

				<button
					class="btn btn-block my-2 btn-primary"
					@click="setCommandResponseType('datasource')"
				>Choose</button>
			</div>

			<div
				class="response-type shadow-sm"
				:class="{'response-type--selected': selectedResponse === 'menu'}"
				@click="setCommandResponseType('menu')"
			>
				<h4>Menu</h4>
				<select name="menu" v-model="commandResponse.resp_menu_id" class="form-control">
					<option
						v-for="menu in menus"
						:value="menu.ds_id"
						:key="`menu-${menu.ds_id}`"
						:selected="commandResponse.resp_menu_id === menu.ds_id"
					>{{ menu.ds_name }}</option>
				</select>
				<button class="btn btn-block my-2 btn-primary" @click="setCommandResponseType('menu')">Choose</button>
			</div>

			<div
				class="response-type shadow-sm"
				:class="{'response-type--selected': selectedResponse === 'shopping_cart'}"
				@click="setCommandResponseType('shopping_cart')"
			>
				<h4>Shoping Cart</h4>
				<select name="menu" v-model="commandResponse.resp_menu_id" class="form-control">
					<option
						v-for="menu in menus"
						:value="menu.ds_id"
						:key="`menu-${menu.ds_id}`"
						:selected="commandResponse.resp_menu_id === menu.ds_id"
					>{{ menu.ds_name }}</option>
				</select>
				<button
					class="btn btn-block my-2 btn-primary"
					@click="setCommandResponseType('shopping_cart')"
				>Choose</button>
			</div>

			<div
				class="response-type shadow-sm"
				:class="{'response-type--selected': selectedResponse === 'component'}"
				@click="setCommandResponseType('component')"
			>
				<h4>Component</h4>

				<select name="component" v-model="commandResponse.resp_component_id" class="form-control">
					<optgroup v-for="component in Object.keys(components)" :label="component" :key="component">
						<option
							v-for="component in components[component]"
							:value="component.comp_id"
							:key="`component-${component.comp_id}`"
							:selected="commandResponse.resp_component_id === component.comp_id"
						>{{ component.comp_title }}</option>
					</optgroup>
				</select>

				<button
					class="btn btn-block my-2 btn-primary"
					@click="setCommandResponseType('component')"
				>Choose</button>
			</div>
		</div>
		<div class="form-actions">
			<b-button
				variant="primary"
				@click="saveCommandResponse"
				class="respone-background-primary pull-right border-0"
				:disabled="!commandResponse || (commandResponse && !commandResponse.resp_type)"
			>
				<font-awesome-icon icon="save" />
				{{ $t('next') }}
			</b-button>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import Utilities from '@/directives/Autocomplete/Utilities'

/**
 * @group CommandResponse
 *
 * Command Response Type
 */
export default {
	name: 'CommandResponseType',

	computed: {
		/**
		 * @vuese
		 *
		 * Get service ID from route path
		 *
		 * @type `Number`
		 *
		 */
		serviceId() {
			return this.$route.params.service_id
		},
		/**
		 * @vuese
		 *
		 * Get command ID from route path
		 *
		 * @type  `Number`
		 */
		commandId() {
			return this.$route.params.command_id
		},

		/**
		 * @vuese
		 *
		 * Type of selected response
		 *
		 * @type  `String`
		 */
		selectedResponse: {
			get() {
				return this.commandResponse.resp_type
			},
			set(responseType) {
				this.commandResponse.resp_type = responseType
			},
		},
	},

	data() {
		return {
			commandResponse: {},
			components: [],
			dataSets: [],
			dataSources: [],
			menus: [],
			user_data_ds_schema: [],
			datasets_list: [],
		}
	},

	methods: {
		/**
		 * @vuese
		 *
		 * Initalize data, Get command response, List of datasets, List of components, and List of datasources
		 */
		async initData() {
			this.getCommandResponseType()
			this.getDatasetsAndMenus()
			this.getComponents()
			this.getDataSources()
			this.get_command_response()
		},

		async getCommandResponseType() {
			try {
				const {data} = await axios.get(`command-response/${this.commandId}/types`)
				if (data.commandResponse) {
					this.saveCommandresponseToStore(data.commandResponse)
					this.commandResponse = data.commandResponse
				}
			} catch (error) {}
		},

		async getDatasetsAndMenus() {
			try {
				const data = await axios.get('/dataset/get_list?type=dataset,menu')
				if (data.data && data.data.status === 1) {
					this.dataSets = data.data.private.filter((value) => value.ds_type === 'dataset')
					this.menus = data.data.private.filter((value) => value.ds_type === 'menu')
				}
			} catch (error) {}
		},

		async getDataSources() {
			try {
				const {data} = await axios.get('/data_sources?all')
				if (data.status) {
					this.dataSources = data.data
				}
			} catch (error) {}
		},

		async getComponents() {
			try {
				const {data} = await axios.get('components')

				this.components = data.components
			} catch (error) {
				console.log(error)
			}
		},

		formatCommandResponse(type) {
			let commandResponse = {resp_type: type}
			switch (type) {
				case 'dataset':
					commandResponse.resp_dataset_id = this.commandResponse.resp_dataset_id
					break
				case 'datasource':
					commandResponse.resp_data_source_id = this.commandResponse.resp_data_source_id
					break
				case 'menu':
					commandResponse.resp_menu_id = this.commandResponse.resp_menu_id
					break;
				case 'shopping_cart':
					commandResponse.resp_menu_id = this.commandResponse.resp_menu_id
					break
				case 'component':
					commandResponse.resp_component_id = this.commandResponse.resp_component_id		
					break;
			}

			return commandResponse
		},

		/**
		 * @vuese
		 *
		 * Save command response
		 *
		 * @async
		 */
		async saveCommandResponse() {
			let commandResponse = (this.commandResponse = this.formatCommandResponse(this.commandResponse.resp_type))

			this.$store.commit('setResponseDataProperty', {
				resp_type: this.commandResponse.resp_type
			});
			try {
				const {data} = await axios.post(`command-response/${this.commandId}/types`, {...commandResponse})
				if (data.commandResponse) {
					this.saveCommandresponseToStore(data.commandResponse).redirectNext()
				}
			} catch (error) {}
		},

		saveCommandresponseToStore(commandResponse) {
			let obj = {
				type: commandResponse.resp_type,
				id: commandResponse.resp_id,
			}
			if (commandResponse.resp_dataset_id && commandResponse.resp_type == 'dataset') {
				obj.resp_dataset_id = commandResponse.resp_dataset_id
			} else if (commandResponse.resp_component_id && commandResponse.resp_type == 'component') {
				obj.resp_component_id = commandResponse.resp_component_id
			}
			this.$store.commit('setSelectedCommandResponse', obj)
			return this
		},

		redirectNext() {
			let type, hasOption

			const commandResponse = this.$store.state.commandResponse

			if (commandResponse.types.hasOwnProperty((type = commandResponse.selected.type))) {
				hasOption = commandResponse.types[type].has_options
				if (hasOption) {
					this.$router.push(`/services/${this.serviceId}/commands/${this.commandId}/result/options/${type}`)
				} else {
					this.$router.push(`/services/${this.serviceId}/commands/${this.commandId}/result/template`)
				}
			}
		},

		notifyInfo(type) {
			let msg = this.$t(`please choose ${type} first`)
			this.$root.notify({
				message: msg,
				status: 'info',
				area: 'topRight',
				TimeLeft: 1,
			})
		},

		setCommandResponseType(type) {
			switch (type) {
				case 'dataset':
					if (!this.commandResponse.resp_dataset_id) {
						this.notifyInfo(type)
						return false
					}
					break
				case 'datasource':
					if (!this.commandResponse.resp_data_source_id) {
						this.notifyInfo(type)
						return false
					}
					break
				case 'menu':
					break;
				case 'shopping_cart':
					if (!this.commandResponse.resp_menu_id) {
						this.notifyInfo(type)
						return false
					}
					break
				case 'component':
					if (!this.commandResponse.resp_component_id) {
						this.notifyInfo(type)
						return false
					}
					break;
			}
			this.$set(this.commandResponse, 'resp_type', type)
		},
		async get_command_response() {
			const res = await axios.get(`/command_response/get/${this.commandId}`)

			if (res.data.status != 1) return

			var record = res.data.data

			if (!is_obj(record.resp_data_source_resp_struct)) {
				record.resp_data_source_resp_struct = {
					title_key: '',
					title_default_value: '',
					subtitle_key: '',
					subtitle_default_value: '',
					media_key: '',
					media_default_value: '',
					item_label_key: '',
					item_label_default_value: '',
					item_value_key: '',
					item_value_default_value: '',
					buttons: [
						{
							item_label_key: '',
							item_label_default_value: '',
							item_value_key: '',
							item_value_default_value: '',
						},
					],
				}
			}
			if (!is_arr(record.resp_static_cards_resp_struct)) {
				record.resp_static_cards_resp_struct = []
			}

			if (!is_arr(record.resp_location_resp_struct)) {
				record.resp_location_resp_struct = []
			}

			if (!record.resp_dataset) {
				record.resp_dataset = this.dataset
			}

			if (!is_arr(record.resp_data_source_resp_struct.buttons)) {
				record.resp_data_source_resp_struct.buttons = [
					{
						item_label_key: record.resp_data_source_resp_struct.item_label_key || '',
						item_label_default_value: record.resp_data_source_resp_struct.item_label_default_value || '',
						item_value_key: record.resp_data_source_resp_struct.item_value_key || '',
						item_value_default_value: record.resp_data_source_resp_struct.item_value_default_value || '',
					},
				]
			}

			if (!is_arr(record.resp_api_resp_struct.buttons)) {
				record.resp_api_resp_struct.buttons = [
					{
						item_label_key: record.resp_api_resp_struct.item_label_key || '',
						item_label_default_value: record.resp_api_resp_struct.item_label_default_value || '',
						item_value_key: record.resp_api_resp_struct.item_value_key || '',
						item_value_default_value: record.resp_api_resp_struct.item_value_default_value || '',
					},
				]
			}

			if (!is_arr(record.resp_dataset.resp.buttons)) {
				record.resp_dataset.resp.buttons = [
					{
						item_label_key: record.resp_dataset.resp.item_label || '',
						item_value_key: record.resp_dataset.resp.item_value || '',
					},
				]
			}

			if (record.resp_user_data_dataset_id) {
				this.generate_ds_schema(res.data.data.resp_user_data_dataset_id)
			}

			if (record.resp_api_resp_struct.receipt && record.resp_api_resp_struct.receipt.dataset_id) {
				this.generate_ds_schema(record.resp_api_resp_struct.receipt.dataset_id)
			} else if (record.resp_user_data_dataset_id) {
				this.generate_ds_schema(record.resp_user_data_dataset_id)
			}

			if (!is_obj(record.resp_api_extra_resp)) {
				var resp_opts_clone = clone(record.resp_api_extra_resp || [])
				record.resp_api_extra_resp = {
					message: '',
					options: resp_opts_clone,
				}
			}

			if (!is_arr(record.resp_menu_extra_options)) {
				record.resp_menu_extra_options = []
			}

			if (!is_arr(record.resp_quick_reply)) {
				record.resp_quick_reply = []
			}
			
			record.resp_dataset

			var data = this.buildCommandResult(record)

			record = Utilities.deepExtend(record, data, true)

			this.$store.commit('setResponseData', record);

			// this.setAutoCompeleteSchema()
		},
		generate_ds_schema(ds_id) {
			this.user_data_ds_schema = []
			for (var i = this.datasets_list.length - 1; i >= 0; i--) {
				if (ds_id == this.datasets_list[i].ds_id) {
					this.user_data_ds_schema = this.datasets_list[i].ds_schema
					break
				}
			}
		},
	},

	created() {
		this.initData()
	},
}
</script>

<style lang="scss" scoped>
$blue: #318af1;

.response-types {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	@media screen and(max-width: 900px) {
		grid-template-columns: 1fr 1fr;
	}
	grid-gap: 2rem;
	.response-type {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		border: 2px solid transparent;
		padding: 1rem 2rem;
		transition: 0.3s all;
		border: 3px solid transparent;
		border-radius: 0.5rem;
		.btn {
			border: 0;
			background: $blue;
		}
		&.response-type--selected {
			border: 3px solid $blue;
		}
	}
}
</style>
